import { useContext } from 'react';
import { LogoutContext } from '../context';
import { NotWrappedError } from '../functions';
var useLogout = function () {
    var context = useContext(LogoutContext);
    if (context === null)
        throw new NotWrappedError();
    return context;
};
export default useLogout;
//# sourceMappingURL=useLogout.js.map